var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9951 1.57554L7.34755 5.83026C7.04418 6.18306 6.88191 6.62758 6.88191 7.09327V10.3672C6.88191 10.4378 6.84663 10.4942 6.78314 10.5225L5.3721 11.228C5.29449 11.2704 5.231 11.2422 5.20278 11.221C5.17455 11.1998 5.11811 11.1575 5.11811 11.0728V7.09327C5.11811 6.62758 4.95585 6.18306 4.65247 5.83026L1.00495 1.57554C0.927528 1.48513 0.884988 1.37001 0.88501 1.25097C0.88501 0.97579 1.11078 0.75 1.38593 0.75H10.6141C10.8892 0.75 11.115 0.97579 11.115 1.25097C11.115 1.37092 11.0727 1.48382 10.9951 1.57554Z",
    stroke: "#020817"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlack);
export default __webpack_public_path__ + "static/media/filter_black.f683d8ea6599b1ea01cd44f921c41d5c.svg";
export { ForwardRef as ReactComponent };